const columns: TableColumn[] = [
  {
    Header: `ID`,
    accessor: `id`,
    dbKey: `id`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Name`,
    accessor: `name`,
    dbKey: `name`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Email`,
    accessor: `email`,
    dbKey: `email`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  // {
  //   Header: `Phone`,
  //   accessor: `phone`,
  //   dbKey: `phone`,
  //   isString: true,
  //   isNumeric: false,
  //   isDate: false,
  //   isBool: false,
  //   isSortable: true
  // },
  // {
  //   Header: `Type`,
  //   accessor: `type`,
  //   dbKey: `type`,
  //   isString: true,
  //   isNumeric: false,
  //   isDate: false,
  //   isBool: false,
  //   isSortable: true
  // },
  // {
  //   Header: `Role`,
  //   accessor: `role`,
  //   dbKey: `role`,
  //   isString: true,
  //   isNumeric: false,
  //   isDate: false,
  //   isBool: false,
  //   isSortable: true
  // },
  {
    Header: `Created`,
    accessor: `createdAt`,
    dbKey: `createdAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Updated`,
    accessor: `updatedAt`,
    dbKey: `updatedAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  }
];

export default columns;
